import SwitchWithLabel from './SwitchWithLabel'

export default SwitchWithLabel
